/**
 * Copyright Motili Inc., 2025 All Rights Reserved
 */

import { ComponentProps } from 'react';
import FormSelect from 'common/components/form/FormSelect';
import styles from './DataGridStyles.module.scss';

type DataGridAdvancedFilterFormSelectProps = ComponentProps<typeof FormSelect>;

const DataGridAdvancedFilterFormSelect = (
    props: DataGridAdvancedFilterFormSelectProps
) => {
    return (
        <FormSelect
            {...props}
            className={styles.advancedFilterFormSelect}
            menuPosition='absolute'
            // @ts-ignore
            styles={{
                // @ts-ignore
                menu: base => ({
                    ...base,
                    position: 'static',
                    zIndex: '2 !important',
                }),
            }}
            menuShouldScrollIntoView={false}
        />
    );
};

export default DataGridAdvancedFilterFormSelect;
